import { Text } from "../ui/text";
import { Message, UploadedFile } from "./message-list";
import AttachBox from "../ai/attach-box";

const SDF_COLOR = "#18988B";

const getMimeTypeCategory = (mimeType: string): "pdf" | "csv" | "image" | "json" => {
  if (mimeType === "application/pdf") return "pdf";
  if (mimeType === "text/csv") return "csv";
  if (mimeType.startsWith("image/")) return "image";
  if (mimeType === "application/json" || mimeType === "text/json") return "json";
  return "csv";
};

const removeJsonExtension = (filename: string) =>
  filename.replace(/\.json$/i, "");

const JsonFileTag = ({ file }: { file: UploadedFile }) => (
  <span
    className="inline-flex items-center text-[14px] font-semibold"
    style={{ color: SDF_COLOR }}
  >
    {removeJsonExtension(file.filename)}
  </span>
);

const UserMessage = ({ message }: { message: Message }) => {
  const hasFiles = message.uploadedFiles && message.uploadedFiles.length > 0;

  const jsonFiles = message.uploadedFiles?.filter(
    (f) => getMimeTypeCategory(f.mimeType) === "json"
  ) ?? [];
  const otherFiles = message.uploadedFiles?.filter(
    (f) => getMimeTypeCategory(f.mimeType) !== "json"
  ) ?? [];

  return (
    <div
      className="
    flex
    flex-col
    gap-[10px]
    px-5
    py-4
    transition-colors
    duration-200
    max-w-[486px]
    backdrop-blur-sm
  "
      style={{
        background: "#F2F2F24D",
        borderRadius: "16px",
        border: "1px solid #FFFFFF",
        boxShadow: "0px 4px 10px 0px #3737370D",
      }}
    >
      {message.sdfJobName && jsonFiles.length === 0 && (
        <span
          className="inline-flex items-center text-[14px] font-semibold"
          style={{ color: SDF_COLOR }}
        >
          {message.sdfJobName}
        </span>
      )}
      {hasFiles && (
        <>
          {otherFiles.length > 0 && (
            <div className="flex flex-wrap gap-[10px]">
              {otherFiles.map((file) => (
                <AttachBox
                  key={file.fileId}
                  id={file.fileId}
                  type={getMimeTypeCategory(file.mimeType) as "pdf" | "csv" | "image"}
                  fileName={file.filename}
                  imageUrl=""
                  hasError={file.uploadStatus !== undefined && file.uploadStatus !== "SUCCESS"}
                />
              ))}
            </div>
          )}
          {jsonFiles.length > 0 && (
            <div className="flex flex-wrap gap-2">
              {jsonFiles.map((file) => (
                <JsonFileTag key={file.fileId} file={file} />
              ))}
            </div>
          )}
        </>
      )}
      <Text variant={"body-lg"} className="text-grey-20 break-all whitespace-pre-wrap">
        {message.message}
      </Text>
    </div>
  );
};

export default UserMessage;
